<template>
  <!-- 操作指南 -->
  <div class="menu-item-r">
    <div class="bl-container">
        <div class="operationGuideTitle">
            {{$t('operationGuide')}}
        </div>
        <div class="operationGuideMain">
            <div v-if="!noAdmin">
                <div class="operationGuideMainTitle text-left">
                    {{$t('面料展展商平台使用指南')}}
                </div>
                <div class="operationGuideMainBox">
                    <video
                        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/mianliao/video/strategy.mp4"
                        class="picture"
                        poster="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/mianliao/video/strategy.png"
                        controls>
                    </video>
                </div>
                <el-button type="primary" class="m20" @click="goLink('/company-info')">{{$t('编辑公司资料')}}</el-button>
            </div>

            <!-- <div class="operationGuideMainTitle text-left">
                {{$t('如何管理展品')}}
            </div>
            <div class="operationGuideMainBox">
                <video
                    src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/ef-img/9_16177677609584"
                    class="picture"
                    poster="https://ef-base-common-img.oss-cn-beijing.aliyuncs.com/ef-img/59194621_1646988077910.jpg"
                    controls>
                </video>
            </div>
            <el-button type="primary" class="m20" @click="goLink('/my-employee-list')">{{$t('编辑展品资料')}}</el-button> -->
        </div>
      
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {

  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language', 'name', 'isLogin', 'info', 'subjectType', 'exhibitionId', 'exhibitorId']),
    noAdmin() {
      return (
        !this.info || (this.info && !this.info.exhibitorEmployee) || (this.info && this.info.exhibitorEmployee && !this.info.exhibitorEmployee.admin)
      )
    }
  },

  methods: {
    goLink(url) {
        this.$router.push(url);
    }
  }
}
</script>
<style lang="stylus" scoped>
.bl-container
    padding-bottom 15px
    margin 30px auto
    background #fbfbfb
.operationGuideTitle{
    width:100%;
    height:40px;
    line-height:40px;
    font-weight: bold;
    font-size:20px;
}
.operationGuideMain{
    width:800px;
    margin:0 auto;
    height:500px;
    text-align:center;
}
.operationGuideMainTitle{
    width:100%;
    height:40px;
    line-height:40px;
    font-weight: bold;
    font-size:18px;
}
.operationGuideMainBox{
    width:100%;
    height:300px;
    text-align:center;
    video{
        width:100%;
        height:100%;
    }
}
.m20{
    margin:20px;
}
</style>
